/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { PayoutAccountItem } from '../../models/payout-account-item';

export interface BookingControllerDeletePayoutAccount$Params {
  id: number;
}

export function bookingControllerDeletePayoutAccount(http: HttpClient, rootUrl: string, params: BookingControllerDeletePayoutAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountItem;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerDeletePayoutAccount.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PayoutAccountItem;
      }>;
    })
  );
}

bookingControllerDeletePayoutAccount.PATH = '/booking/wallet/payout_accounts/{id}';
